module.exports = __webpack_public_path__ + "static/media/img_404.09229de0.svg";